module.exports = __webpack_public_path__ + "img/img2d.64c8a957.png";